import api from '@/utils/api'

export default {
    getLeagueGroups(page, size, season, phase) {
        const filter = '"active": true'
        const range = '?seasonId=' + season.id + '&phase=' + phase
        return api.get('league-groups' + (page ? range : '') + (season ? '' : `&filter=${encodeURIComponent('{' + filter + '}')}`))
    },

    getLeagueGroup(id) {
        return api.get(`league-groups/${id}`)
    },

    getAllLeagueGroups() {
        return api.get('league-groups/all')
    }
}
